import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo-container">
      <img src="/logo_endo.png" alt="Endorah Logo" className="logo-image" />
    </div>
  );
};

export default Logo;
